let runtimeConfig = null;

export const loadConfig = async () => {
    const res = await fetch("/config.json");
    runtimeConfig = await res.json();
};

export const getMsalConfig = () => {
    if (!runtimeConfig) {
        throw new Error("Config not loaded");
    }

    return {
        auth: {
            clientId: runtimeConfig.PETPLACE_B2C_CLIENTID,
            authority: runtimeConfig.PETPLACE_B2C_SIGNUP,
            knownAuthorities: [runtimeConfig.PETPLACE_B2C_TENANT],
            redirectUri: runtimeConfig.PETPLACE_URL
        }
    };
};

export const loginRequest = {
    scopes: ["openid", "profile"]
};